module.exports = __webpack_public_path__ + "static/media/logo-image-white.bed5f541.png";